<template>
  <div class="index py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.domain.list")}}</span>
    <div class="searchable-list-container">
      <AveineDomainList :APIbaseURL="APIbaseURL" :adminMode="true"/>
    </div>
  </div>
</template>

<script>
import { AveineDomainList } from 'aveine-domain'
export default {
  name: 'Index',
  data() {
    return {
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  components: {
    AveineDomainList
  }
}
</script>
